import 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';

var LoadingSpinner = _ref => {
  var {
    bgColor,
    color,
    duration = 2,
    size = '14px',
    translateX = '100px'
  } = _ref;
  var theme = useTheme();
  var bgColorWithTheme = bgColor !== null && bgColor !== void 0 ? bgColor : theme.COLORS.background;
  var colorWithTheme = color !== null && color !== void 0 ? color : theme.COLORS.primary;
  return jsx(Style.LoadingSpinnerContainer, {
    bgColor: bgColorWithTheme
  }, jsx(Style.Overlay, null, jsx(Style.Dot, {
    dotColor: colorWithTheme,
    translateX: translateX,
    duration: duration,
    dotSize: size
  }), jsx(Style.Dot, {
    dotColor: colorWithTheme,
    translateX: translateX,
    duration: duration,
    dotSize: size
  }), jsx(Style.Dot, {
    dotColor: colorWithTheme,
    translateX: translateX,
    duration: duration,
    dotSize: size
  })));
};

export { LoadingSpinner };
